export default __webpack_public_path__ + "static/ai-marketing-6--mobile-13f4ff3967c9622bf9aa300ffb92950d.webp";